import { Component, Input } from "@angular/core";
import { SharedServices } from "../../shared.service";
import { Router } from "@angular/router";
import { infoCredentialResponse } from "src/app/interfaces/response/infoCredentialResponse";
import { MatDialog } from "@angular/material/dialog";
import { DialogRegisterComponent } from "../dialog-register/dialog-register.component";


@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})

export class BannerComponent {
  @Input() titleComponent: string = '';
  name: string = ''

  showInfo = false;
  showButton: boolean = false
  imgLogin: string = ''
  showImgEps: boolean = false

  datainfoCredential!: infoCredentialResponse


  constructor(
    private sharedServices: SharedServices,
    private router: Router,
    public dialog: MatDialog

  ) {
    this.showImgEps = this.sharedServices.userLogin.rol == 'EPS' ? true : false
    this.imgLogin = this.sharedServices.userLogin?.urlEps ?? ''
    this.name = this.sharedServices.userLogin.name
    this.datainfoCredential = this.sharedServices.infoCredential
    this.showButton = this.sharedServices.userLogin.administrador == 1 ? true : false
  }

  toggleInfo() {
    
    this.showInfo = !this.showInfo;
  }

  exit() {
    localStorage.clear()
    this.router.navigateByUrl('login');

  }

  openDialogRegister() {
    const dialogRef = this.dialog.open(DialogRegisterComponent);

    dialogRef.afterClosed().subscribe(result => {

    });
  }
}